/**
 * Labstep
 *
 * @module grid/SmartTableProtocolValue/components/ToolPanel/Section/Item
 * @desc Draggable item for Entity DataGrid column options section
 */

import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { SortableItemDragHandle } from 'labstep-web/core/Sortable/Item/DragHandle';
import { SortableItemRef } from 'labstep-web/core/Sortable/Item/Ref';
import type { IEntityDataGridToolPanelSectionItemProps } from 'labstep-web/grid/SmartTableProtocolValue/services/grid-smart-table-protocol-value.service';
import { SectionType } from 'labstep-web/grid/services/grid.service';
import { objectOrFunction } from 'labstep-web/services/react.service';
import type React from 'react';
import styles from './styles.module.scss';

export const EntityDataGridToolPanelSectionItem: React.FC<
  IEntityDataGridToolPanelSectionItemProps
> = ({ column, section, onToggleColumnVisible }) => {
  const colId = column.getId();
  const isVisible = section === SectionType.visible;
  const headerComponentParams = objectOrFunction(
    column.getColDef().headerComponentParams,
    {
      column,
    },
  );
  const { metadata, protocolValue } = headerComponentParams;

  return (
    <SortableItemRef id={colId}>
      {({ style }): React.ReactElement => (
        <Flex
          data-testid="column-option"
          style={style}
          shrink={0}
          key={colId}
        >
          {isVisible && <SortableItemDragHandle />}
          <Flex grow className={styles.item}>
            <div className={styles.name}>
              {metadata && metadata.is_input && (
                <Icon name="sign in" popup={{ content: 'Input' }} />
              )}{' '}
              {metadata && metadata.is_output && (
                <Icon name="sign out" popup={{ content: 'Output' }} />
              )}{' '}
              {protocolValue && protocolValue.is_input && (
                <Icon name="sign in" popup={{ content: 'Input' }} />
              )}{' '}
              {protocolValue && protocolValue.is_output && (
                <Icon name="sign out" popup={{ content: 'Output' }} />
              )}{' '}
              <Icon
                name={headerComponentParams.icon}
                cornerIcon={headerComponentParams.cornerIcon}
              />
              {headerComponentParams.toolPanelColumnName}
            </div>
            {colId !== 'row_number' && (
              <div
                className={styles.iconContainer}
                onClick={(): void => onToggleColumnVisible(colId)}
              >
                <Icon
                  popup={{ content: 'Hide Column' }}
                  className={styles.icon}
                  color="grey"
                  name={'eye slash'}
                />
              </div>
            )}
          </Flex>
        </Flex>
      )}
    </SortableItemRef>
  );
};
